exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".btn-product-merchants[data-v-ce726c9c]{font-size:.75rem}", ""]);

